import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    previousSuggestion: string;
    nextSuggestion: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for previous suggestion button */
            previousSuggestion: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CarouselControls.previousSuggestion?c=3cxdc3i3ru2nj", defaultMessage: "Previous suggestion" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility label for next suggestion button */
            nextSuggestion: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CarouselControls.nextSuggestion?c=2x8m9xx1ktihn", defaultMessage: "Next suggestion" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
